import { z } from 'zod';
import { MeasureEvaluationCurrentSituationSchema } from './measure-evaluation.schema.js';

export const PriorMeasureEvaluationListItemSchema = z.object({
    sourceApplicabilityId: z.string(),
    assetGroupName: z.string(),
    assetGroupNo: z.union([z.string(), z.number()]),
    category: z.string().nullable(),
    implementationStatus: z.string().nullable(),
    updatedAt: z.coerce.date().optional(),
    roadMapLinkCount: z.number().int().min(0),
    compensatoryLinkCount: z.number().int().min(0),
});

export const PriorMeasureEvaluationDetailSchema = z.object({
    source: z.object({
        applicabilityId: z.string(),
        assetGroupName: z.string(),
        assetGroupNo: z.union([z.string(), z.number()]),
        category: z.string().nullable(),
    }),
    currentSituationAnalysis: MeasureEvaluationCurrentSituationSchema,
    linksToApplyIds: z.object({
        roadMapWorkPackageIds: z.array(z.string()),
        compensatoryControlIds: z.array(z.string()),
    }),
    linkCounts: z.object({
        roadMap: z.number().int().min(0),
        compensatory: z.number().int().min(0),
        skippedAlreadyLinked: z.number().int().min(0),
    }),
});
